// https://usehooks-typescript.com/react-hook/use-interval
import { useEffect, useRef } from 'react';

function useInterval(callback: () => void, delay: number | null) {
  const savedCallback = useRef(null);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      savedCallback.current();
    }

    const id = setInterval(tick, delay);

    return () => {
      clearInterval(id);
    };
  }, [callback, delay]);
}

export default useInterval;
